// extracted by mini-css-extract-plugin
export default {"name":"UsersTable_name__l0l0+","table":"UsersTable_table__uqBm5","organization":"UsersTable_organization__L3RiA","mail":"UsersTable_mail__eTJsz","link":"UsersTable_link__wt6nQ"};